import React from "react";

function AlertLineMobile(props) {
  const truncateText = (text, length) => {
    if (text.length > length) {
      return text.substring(0, length) + "...";
    } else {
      return text;
    }
  };

  return (
    <div
      className={
        props.typeOfAlert === 1
          ? "formLine-mobile-version2 blue-alert"
          : props.typeOfAlert === 2
          ? "formLine-mobile-version2 orange-alert"
          : "formLine-mobile-version2 red-alert"
      }
    >
      <div className="formLineBlock1Mobile3 alertTextColorMobile">
        {props.typeOfAlert === 1
          ? "Reminder"
          : props.typeOfAlert === 2
          ? "Allergy"
          : props.typeOfAlert === 3
          ? "Alert"
          : ""}
      </div>

      <div className="formLineBlock2mobile2 alertTextColorMobile">
        {truncateText(props.content, 8)}
      </div>
      <div className="formLineBlock2mobile2Bis alertTextColorMobile">
        {/* {formatDate(props.date)} */}
        {props.date}
      </div>

      {/* <div className="formLineBlock3 alertTextColorMobile">{props.notedBy}</div> */}
    </div>
  );
}

export default AlertLineMobile;
